import { z } from "zod";

/**
 * An RFC-3339 timestamp. `offset: true` accepts a numeric UTC offset (`+02:00`) alongside
 * `Z`, both of which RFC 3339 allows.
 *
 * The refinement caps the fractional part at microseconds to match PostgreSQL. Zod's `precision`
 * option requires *exactly* that many digits, so it can't express "up to 6"; without this check a
 * nanosecond input would validate here and then throw in `instantToPostgresTimestamp`,
 * turning a client error into a 500.
 */
export const InstantString = z.iso
    .datetime({ offset: true })
    .refine((value) => (/\.(\d+)/.exec(value)?.[1].length ?? 0) <= 6, {
        message: "Timestamps support at most microsecond (6-digit) precision",
    });
